import React from 'react'
import './styles.scss'

const PricingHero = ({ heroData: { title, tagline } }) => {
  return (
    <div className="pricing-hero">
      <div className="container">
        <h6>Pricing</h6>
        <h1>{title.text}</h1>
        <p>{tagline.text}</p>
      </div>
    </div>
  )
}

export default PricingHero
